import { apiFetch } from './client.js';

/**
 * Cliente de "quién está usando OPUS ai ahora" (solo staff Ecosoft).
 * El porqué y los límites del dato están en `apps/api/src/lib/presencia.ts`.
 */

export interface SesionActiva {
  userId: string;
  nombre: string;
  email: string | null;
  empresa: string;
  tenantSlug: string;
  /** Minutos desde su última acción real. `null` = sólo tiene una pestaña abierta. */
  haceMinutos: number | null;
  ultimaAccion: string | null;
  ultimaRuta: string | null;
  canalesAbiertos: number;
  desde: string;
}

export interface SesionesActivas {
  /** Hizo algo en los últimos 5 minutos: hay una persona ahí. */
  trabajando: number;
  conPestanaAbierta: number;
  total: number;
  ventanaMinutos: number;
  /** Desde cuándo corre este motor: el registro arranca vacío en cada deploy. */
  motorDesde: string;
  sesiones: SesionActiva[];
}

export function getSesionesActivas(ventanaMinutos = 30): Promise<SesionesActivas> {
  return apiFetch<SesionesActivas>(
    `/api/v1/staff/sesiones-activas?ventanaMinutos=${ventanaMinutos}`,
  );
}
